import React, { useEffect, useState } from "react";
import { FiArrowUpCircle } from "react-icons/fi"; // Import de l'icône
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    // Fonction pour afficher/masquer le bouton en fonction du défilement
    const toggleVisibility = () => {
      const scrollPosition = window.pageYOffset;
      if (scrollPosition > 150) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    // Ajout de l'écouteur d'événement pour le défilement
    window.addEventListener("scroll", toggleVisibility);

    // Nettoyage de l'écouteur
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  useEffect(() => {
    // Faire défiler vers le haut lors du changement de route
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div
      className={`progress-wrap cursor-pointer ${
        visible ? "active-progress" : ""
      }`}
      onClick={scrollToTop}
    >
      <FiArrowUpCircle size={45} color="#1d678e" />
    </div>
  );
};

export default ScrollToTop;
